import React from 'react';

import { SpotlightManager } from '@atlaskit/onboarding';

import { fg } from '@confluence/feature-gating';

export const LiveDocSpotlightsTourManager = React.memo(
	({ children }: { children: React.ReactNode }) => {
		// Remove <SpotlightManager> when cc_modernize_ga_changeboarding is enabled
		// This will allow the Modernize changeboarding including Nav4 to be managed by the <SpotlightManager> in PageLayout level
		// We still keep the <SpotlightManager> in place for exiting Live Doc changeboarding EAP and Open beta users.
		// We will remove this `LiveDocSpotlightsTourManager` when cc_modernize_ga_changeboarding is rolled out
		if (fg('cc_modernize_ga_changeboarding')) {
			return <>{children}</>;
		}

		return <SpotlightManager>{children}</SpotlightManager>;
	},
);
